(() => {
  'use strict';
  const configNode = document.getElementById('bc-demo-config');
  const config = configNode ? JSON.parse(configNode.textContent) : null;
  const key = 'bonsai-cat-demo-v1';
  const money = cents => new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(cents / 100);
  const validQuantity = value => Number.isSafeInteger(Number(value)) && Number(value) >= 1;
  let quantity = 0;
  if (config) {
    try { const stored = Number(sessionStorage.getItem(key)); if (validQuantity(stored)) quantity = stored; } catch { /* Cart can open; mutations report storage errors. */ }
  }
  const dialog = () => document.getElementById('bc-demo-dialog');
  let lastFocus;
  function openCart(trigger, added = false) {
    const target = dialog();
    if (!target) return;
    lastFocus = trigger || document.activeElement;
    target.querySelector('[data-demo-status]').textContent = added ? config.added : '';
    renderCart();
    if (!target.open) target.showModal();
    target.querySelector('[data-demo-close]').focus();
  }
  function saveCart(next, errorNode) {
    if (!Number.isSafeInteger(next) || next < 0) { if(errorNode) errorNode.textContent = config.quantityError; return false; }
    try { sessionStorage.setItem(key, String(next)); }
    catch { if(errorNode) errorNode.textContent = config.storageError; return false; }
    quantity = next;
    document.querySelectorAll('[data-cart-error], [data-demo-error]').forEach(el => { el.textContent = ''; });
    renderCart();
    return true;
  }
  function renderCart() {
    if (!config) return;
    document.querySelectorAll('[data-demo-count]').forEach(el => { el.textContent = quantity; });
    document.querySelectorAll('[data-demo-price]').forEach(el => { el.textContent = money(config.price); });
    document.querySelectorAll('[data-demo-cart]').forEach(el => {
      el.querySelector('[data-cart-empty]').hidden = quantity !== 0;
      el.querySelector('[data-cart-line]').hidden = quantity === 0;
      el.querySelector('[data-cart-quantity]').value = quantity || 1;
      el.querySelector('[data-cart-total]').textContent = money(quantity * config.price);
    });
  }
  const cleanups = new WeakMap();
  const motionSeen = new WeakSet();
  const revealObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) entry.target.classList.add('bc-reveal-enter');
        revealObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.08 }) : null;
  function init(root = document) {
    root.querySelectorAll('[data-bc-reveal]').forEach(element => {
      if (!motionSeen.has(element)) { motionSeen.add(element); revealObserver?.observe(element); }
    });
    root.querySelectorAll('[data-bc-product]').forEach(section => {
      if (cleanups.has(section)) return;
      const input = section.querySelector('input[name="quantity"]');
      const original = section.querySelector('[data-demo-submit], .product-form__submit');
      if (!input || !original) return;
      const sticky = section.querySelector('.bc-sticky');
      const stickyButton = sticky.querySelector('button');
      const form = document.getElementById(section.dataset.formId);
      const sync = () => {
        section.querySelector('[data-sticky-quantity]').textContent = input.value;
        stickyButton.textContent = original.querySelector('span')?.textContent || original.textContent;
        stickyButton.disabled = original.disabled || original.getAttribute('aria-disabled') === 'true';
      };
      section.querySelectorAll('[data-quantity-step]').forEach(button => button.addEventListener('click', () => {
        if (!input.checkValidity()) input.value = input.min || '1';
        if (button.dataset.quantityStep === '1') input.stepUp(); else input.stepDown();
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }));
      input.addEventListener('input', sync);
      input.addEventListener('change', sync);
      stickyButton.addEventListener('click', () => {
        if (!input.checkValidity()) { input.reportValidity(); input.focus(); return; }
        original.click();
      });
      // Native form remains Dawn's. Validate the associated quantity before its Ajax handler.
      if (!config && form) form.addEventListener('submit', event => {
        if (!input.checkValidity()) { event.preventDefault(); event.stopImmediatePropagation(); input.reportValidity(); }
      }, true);
      const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
        const entry = entries[0];
        sticky.hidden = entry.isIntersecting || entry.boundingClientRect.bottom > 0;
      }) : null;
      observer?.observe(original);
      const mutation = new MutationObserver(sync);
      mutation.observe(original, { attributes: true, childList: true, subtree: true, characterData: true });
      sync();
      cleanups.set(section, () => { observer?.disconnect(); mutation.disconnect(); revealObserver?.unobserve(section); });
    });
    renderCart();
  }
  document.addEventListener('click', event => {
    const target = event.target.closest('button, a');
    if (!target) return;
    if (target.matches('[data-demo-open]') && config) { event.preventDefault(); openCart(target); }
    if (target.matches('[data-demo-close]')) dialog()?.close();
    if (target.matches('[data-demo-submit]') && config && !target.disabled) {
      const section = target.closest('[data-bc-product]');
      const input = section.querySelector('input[name="quantity"]');
      const error = section.querySelector('[data-demo-error]');
      if (!validQuantity(input.value)) { error.textContent = config.quantityError; input.reportValidity(); return; }
      if (saveCart(quantity + Number(input.value), error)) {
        target.classList.remove('bc-added');
        requestAnimationFrame(() => target.classList.add('bc-added'));
        openCart(target, true);
      }
    }
    if (target.matches('[data-cart-remove]') && config) {
      if (saveCart(0, target.closest('[data-demo-cart]').querySelector('[data-cart-error]'))) {
        const cart = target.closest('[data-demo-cart]');
        cart.querySelector('.bc-text-link[href]').focus();
      }
    }
    if (target.closest('.bc-mobile-nav') && target.tagName === 'A') target.closest('details').open = false;
  });
  document.addEventListener('input', event => {
    if (!event.target.matches('[data-cart-quantity]') || !config || !validQuantity(event.target.value)) return;
    saveCart(Number(event.target.value), event.target.closest('[data-demo-cart]').querySelector('[data-cart-error]'));
  });
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-cart-quantity]') || !config) return;
    const error = event.target.closest('[data-demo-cart]').querySelector('[data-cart-error]');
    if (!validQuantity(event.target.value)) { error.textContent = config.quantityError; event.target.reportValidity(); return; }
    saveCart(Number(event.target.value), error);
  });
  // Prevent implicit Enter submission in isolated demo forms.
  document.addEventListener('submit', event => {
    if (event.target.matches('[data-demo-form]')) { event.preventDefault(); event.target.querySelector('[data-demo-submit]').click(); }
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('.bc-mobile-nav[open]').forEach(el => { el.open = false; el.querySelector('summary').focus(); });
  });
  dialog()?.addEventListener('close', () => { if (lastFocus?.isConnected) lastFocus.focus(); });
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-bc-product]').forEach(section => { cleanups.get(section)?.(); cleanups.delete(section); }));
  init();
})();
